document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.querySelector('.ace-menu-container');
    const openMenuBtn = document.querySelector('.ace-open-menu');
    const closeMenuBtn = document.querySelector('.ace-close-menu');
    const mobileLinks = document.querySelectorAll('.mob-nav-menu-item');
    const navLinks = document.querySelectorAll('.nav-menu-item, .mob-nav-menu-item');
    const filterButtons = document.querySelectorAll('.filter-btn');
    const eventCards = Array.from(document.querySelectorAll('.event-card'));
    const eventsGrid = document.querySelector('#events-grid');
    const prevPageBtn = document.querySelector('#prev-page');
    const nextPageBtn = document.querySelector('#next-page');
    const paginationNumbers = document.querySelector('#pagination-numbers');
    const paginationContainer = document.querySelector('#pagination');
    const sliderDots = document.querySelector('#slider-dots');
    const modal = document.querySelector('#reserve-modal');
    const modalClose = document.querySelector('#modal-close');
    const eventNameInput = document.querySelector('#event-name');
    const reserveForm = document.querySelector('.reserve-form');
    const contactForm = document.querySelector('#contact-form');
    const formMessage = document.querySelector('#form-message');

    let currentPage = 1;
    const cardsPerPage = 6;

    if (mobileMenu && openMenuBtn && closeMenuBtn) {
        const toggleMenu = () => {
            const isOpen = mobileMenu.classList.contains('is-open');
            mobileMenu.classList.toggle('is-open');
            openMenuBtn.classList.toggle('active');
            openMenuBtn.setAttribute('aria-expanded', !isOpen);
        };

        openMenuBtn.addEventListener('click', toggleMenu);
        closeMenuBtn.addEventListener('click', toggleMenu);

        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                mobileMenu.classList.remove('is-open');
                openMenuBtn.classList.remove('active');
                openMenuBtn.setAttribute('aria-expanded', 'false');
            });
        });

        window.matchMedia('(min-width: 768px)').addEventListener('change', e => {
            if (e.matches) {
                mobileMenu.classList.remove('is-open');
                openMenuBtn.classList.remove('active');
                openMenuBtn.setAttribute('aria-expanded', 'false');
            }
        });
    }

    navLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                window.scrollTo({
                    top: targetSection.offsetTop - 70,
                    behavior: 'smooth'
                });

                navLinks.forEach(item => item.classList.remove('current', 'mob-current'));
                link.classList.add('current', 'mob-current');

                if (mobileMenu) {
                    mobileMenu.classList.remove('is-open');
                    openMenuBtn.classList.remove('active');
                    openMenuBtn.setAttribute('aria-expanded', 'false');
                }
            }
        });
    });

    const hash = window.location.hash;
    if (hash) {
        const targetSection = document.getElementById(hash.substring(1));
        if (targetSection) {
            window.scrollTo({
                top: targetSection.offsetTop - 70,
                behavior: 'smooth'
            });

            navLinks.forEach(link => {
                link.classList.remove('current', 'mob-current');
                if (link.getAttribute('href') === hash) {
                    link.classList.add('current', 'mob-current');
                }
            });
        }
    } else {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const isMobile = () => window.innerWidth < 768;

    const updatePagination = filteredCards => {
        if (isMobile()) {
            paginationContainer.style.display = 'none';
            return;
        }

        const totalCards = filteredCards.length;
        const totalPages = Math.ceil(totalCards / cardsPerPage);

        paginationNumbers.innerHTML = '';
        for (let i = 1; i <= totalPages; i++) {
            const pageNumber = document.createElement('span');
            pageNumber.classList.add('page-number');
            pageNumber.textContent = i;
            if (i === currentPage) pageNumber.classList.add('active');
            pageNumber.addEventListener('click', () => {
                currentPage = i;
                updateCards(filteredCards);
            });
            paginationNumbers.appendChild(pageNumber);
        }

        prevPageBtn.disabled = currentPage === 1;
        nextPageBtn.disabled = currentPage === totalPages;
    };

    const updateSliderDots = filteredCards => {
        if (!isMobile()) {
            sliderDots.innerHTML = '';
            return;
        }

        const cardsPerSlide = window.innerWidth < 480 ? 1 : 2;
        const totalSlides = Math.ceil(filteredCards.length / cardsPerSlide);

        sliderDots.innerHTML = '';
        for (let i = 0; i < totalSlides; i++) {
            const dot = document.createElement('div');
            dot.classList.add('slider-dot');
            if (i === 0) dot.classList.add('active');
            sliderDots.appendChild(dot);
        }

        eventsGrid.addEventListener('scroll', () => {
            const slideIndex = Math.round(eventsGrid.scrollLeft / (eventsGrid.scrollWidth / totalSlides));
            document.querySelectorAll('.slider-dot').forEach((dot, index) => {
                dot.classList.toggle('active', index === slideIndex);
            });
        });
    };

    const updateCards = filteredCards => {
        if (isMobile()) {
            eventCards.forEach(card => {
                card.classList.remove('visible');
                card.style.display = 'none';
            });

            filteredCards.forEach(card => {
                card.style.display = 'block';
                card.classList.add('visible');
            });

            updateSliderDots(filteredCards);
        } else {
            eventCards.forEach(card => {
                card.classList.remove('visible');
                card.style.display = 'none';
            });

            const startIndex = (currentPage - 1) * cardsPerPage;
            const endIndex = startIndex + cardsPerPage;
            filteredCards.slice(startIndex, endIndex).forEach(card => {
                card.style.display = 'block';
                card.classList.add('visible');
            });

            updatePagination(filteredCards);
        }
    };

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            filterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            const filter = button.getAttribute('data-filter');
            currentPage = 1;

            const filteredCards = eventCards.filter(card => {
                const city = card.getAttribute('data-city');
                const type = card.getAttribute('data-type') || '';
                return filter === 'all' || city === filter || type === filter;
            });

            updateCards(filteredCards);
        });
    });

    prevPageBtn.addEventListener('click', () => {
        if (currentPage > 1) {
            currentPage--;
            const filteredCards = eventCards.filter(card => {
                const filter = document.querySelector('.filter-btn.active').getAttribute('data-filter');
                const city = card.getAttribute('data-city');
                const type = card.getAttribute('data-type') || '';
                return filter === 'all' || city === filter || type === filter;
            });
            updateCards(filteredCards);
        }
    });

    nextPageBtn.addEventListener('click', () => {
        const filter = document.querySelector('.filter-btn.active').getAttribute('data-filter');
        const filteredCards = eventCards.filter(card => {
            const city = card.getAttribute('data-city');
            const type = card.getAttribute('data-type') || '';
            return filter === 'all' || city === filter || type === filter;
        });
        const totalPages = Math.ceil(filteredCards.length / cardsPerPage);
        if (currentPage < totalPages) {
            currentPage++;
            updateCards(filteredCards);
        }
    });

    eventCards.forEach(card => {
        const reserveBtn = card.querySelector('.reserve-btn');
        if (reserveBtn) {
            reserveBtn.addEventListener('click', () => {
                const eventName = reserveBtn.getAttribute('data-event');
                eventNameInput.value = eventName;
                modal.classList.add('active');
            });
        }
    });

    modalClose.addEventListener('click', () => {
        modal.classList.remove('active');
    });

    modal.addEventListener('click', e => {
        if (e.target === modal) {
            modal.classList.remove('active');
        }
    });

    reserveForm.addEventListener('submit', e => {
        e.preventDefault();
        modal.classList.remove('active');
        alert('Reservation submitted successfully!');
    });

    updateCards(eventCards);

    window.addEventListener('resize', () => {
        const filteredCards = eventCards.filter(card => {
            const filter = document.querySelector('.filter-btn.active').getAttribute('data-filter');
            const city = card.getAttribute('data-city');
            const type = card.getAttribute('data-type') || '';
            return filter === 'all' || city === filter || type === filter;
        });
        updateCards(filteredCards);
    });

    if (contactForm) {
        contactForm.addEventListener('submit', function(event) {
            event.preventDefault();
            const form = this;
            const name = form.querySelector('#name').value.trim();
            const email = form.querySelector('#email').value.trim();
            const message = form.querySelector('#message').value.trim();

            if (!name || !email || !message) {
                formMessage.textContent = 'Please fill in all fields.';
                formMessage.className = 'form-message error';
                return;
            }

            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
                formMessage.textContent = 'Please provide a valid email address.';
                formMessage.className = 'form-message error';
                return;
            }

            setTimeout(() => {
                formMessage.textContent = 'Message sent successfully! Thank you for contacting us.';
                formMessage.className = 'form-message success';
                form.reset();
            }, 1000);
        });
    }
});